"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _semanticUiReact = require("semantic-ui-react");

var _Constants = require("../../00_environment/Constants");

var _Fonts = require("../../00_environment/Fonts");

var _Page = _interopRequireDefault(require("../../01_atoms/Page"));

var _Bottom = _interopRequireDefault(require("../../01_atoms/Bottom"));

var _Container = _interopRequireDefault(require("../../01_atoms/Container"));

var _Button = _interopRequireDefault(require("../../01_atoms/Button"));

var _Title = _interopRequireDefault(require("../../01_atoms/Title"));

var _whatsapp = _interopRequireDefault(require("../../../assets/whatsapp.svg"));

var _logo = _interopRequireDefault(require("../../../assets/logo"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var BetaOnboardingWaitingPageUI = function BetaOnboardingWaitingPageUI(_ref) {
  var translatorForNamespace = _ref.translatorForNamespace,
      onLogout = _ref.onLogout;
  var t = translatorForNamespace('BetaOnboardingWaitingPageUI');
  return /*#__PURE__*/_react["default"].createElement(_Page["default"], null, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      flex: '1',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column'
    }
  }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Image, {
    width: 64,
    src: _logo["default"],
    style: {
      margin: 20
    }
  }), /*#__PURE__*/_react["default"].createElement(_Title["default"], {
    style: {
      textAlign: 'center',
      lineHeight: '1.4',
      width: '80vw'
    }
  }, t('Estas a un paso de descubrir'), /*#__PURE__*/_react["default"].createElement("br", null), t('la '), /*#__PURE__*/_react["default"].createElement("strong", null, t('mejor forma')), t(' de comprar'), /*#__PURE__*/_react["default"].createElement("br", null), t('tus boletos de bus')), /*#__PURE__*/_react["default"].createElement(_Title["default"], {
    style: {
      textAlign: 'center',
      lineHeight: '1.4',
      width: '80vw',
      marginTop: 20,
      fontWeight: 300
    }
  }, t('Mucha gente esta pidiendo inscribirse a {appName}.', {
    appName: _Constants.appName
  }), /*#__PURE__*/_react["default"].createElement("br", null), t('Por favor, espere tu turno para ingresar')), /*#__PURE__*/_react["default"].createElement(_Title["default"], {
    style: {
      textAlign: 'center',
      lineHeight: '1.4',
      width: '80vw',
      marginTop: 30,
      fontSize: '1rem'
    }
  }, "Comparte ".concat(_Constants.appName, " con tus amigos para ingresar mas rapido!")), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    color: "#01e675",
    style: {
      marginTop: 10,
      height: 40,
      borderRadius: 5,
      padding: 0,
      paddingLeft: 10,
      paddingRight: 10
    },
    onClick: function onClick() {
      window.location.href = "whatsapp://send?text=".concat(encodeURIComponent("Mira: ".concat(_Constants.appName, " es una app para comprar boletos de bus desde tu movil.\nNo puedo esperar!\n\n").concat(_Constants.appWebsite)));
    }
  }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Image, {
    src: _whatsapp["default"],
    avatar: true
  }), t('Comparte {appName} en WhatsApp', {
    appName: _Constants.appName
  }))), /*#__PURE__*/_react["default"].createElement(_Bottom["default"], null, /*#__PURE__*/_react["default"].createElement(_Container["default"], {
    style: {
      textAlign: 'center'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: (0, _Fonts.withDangerLinkButtonFont)({
      textDecoration: 'none',
      cursor: 'pointer'
    }),
    onClick: function onClick() {
      // reactSwipeEl.next();
      onLogout();
    }
  }, t('Log out')))));
};

var _default = BetaOnboardingWaitingPageUI;
exports["default"] = _default;